<template>
  <div class="module-list">
    <div class="part-container">
      <div class="left-info">
        <TitleWrap title="Purchase Records" partName="Transaction Records">
          <div class="item-summary">
            The Transaction Records section displays a player's personal trading history, sorted by transaction
            completion time by default.
          </div>
          <div class="item-summary">
            Shows a detailed log of all items purchased by the player.
          </div>
        </TitleWrap>
      </div>
      <div class="right-content">
        <div class="swiper-outer">
          <svg-icon icon-class="playDetails_931_449_border" class-name="border-svg" />
          <div class="swiper-padding">
            <div class="img-wrap">
              <img src="@/assets/images/playDetails/InGame/records1.webp" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="part-container">
      <div class="left-info">
        <TitleWrap title="Sale Records" partName="Transaction Records">
          <div class="item-summary">
            The Transaction Records section displays a player's personal trading history, sorted by transaction
            completion time by default.
          </div>
          <div class="item-summary">
            Shows a detailed log of all items sold by the player.
          </div>
        </TitleWrap>
      </div>
      <div class="right-content">
        <div class="swiper-outer">
          <svg-icon icon-class="playDetails_931_449_border" class-name="border-svg" />
          <div class="swiper-padding">
            <div class="img-wrap">
              <img src="@/assets/images/playDetails/InGame/records2.webp" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TitleWrap from "../titleWrap";
export default {
  components: { TitleWrap },
  props: {},
  data() {
    return {}
  },
  mounted() { },
  methods: {}
}
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>